import React, { Suspense, useLayoutEffect, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ProductContextProvider } from '../pages/pre-built/products/ProductContext';
import { UserContextProvider } from '../../src/listgsa/components/UserContext';
import { RedirectAs404 } from '../utils/Utils';
import Sales from '../pages/Sales';
import Crypto from '../pages/Crypto';
import Analytics from '../pages/Analytics';
import ViewExpoCustomReport from '../Exportation/Reports/custom-report/view-custom-report';
import MetricsHome from '../pages/app/MetricsHome';
import RolMetricProtectedRoute from '../components/RolMetricProtectedRoute';

import Muestras from '../muestras';

import FollowupReport from '../Exportation/followUp/Components/followupExpoReport';
import { UserManagement } from '../userManagement';
import { MacroUpdate } from '../Exportation/macroUpdate';
import { NewOrder } from '../Exportation/followUp/Components/NewOrder/NewOrder';
import Helperdocuments from '../Exportation/followUp/Components/helperdocuments';
import TemporalesMro from '../temporals/temporariesMro';

const RemitosAltas = lazy(() => import('../Remitos/Altas/RemitosAltas'));
const RemitosListado = lazy(() => import('../Remitos/Lista/RemitosListado'));
const RemitosConfig = lazy(() => import('../Remitos/Configuracion/config'));
const RemitosAlertas = lazy(() => import('../Remitos/Alertas/alertas'));

const AutomatizationsGestorImpo = lazy(() => import('../automatizaciones/AutomatizationsGestorImpo'));
const AutomatizationsGestorExpo = lazy(() => import('../automatizaciones/AutomatizationsGestorExpo'));
const SSBReportsDashboard = lazy(() => import('../automatizaciones/SSBReportsDashboard'));
const ImporterAutomatizaciones = lazy(() => import('../Importer/automatizacion/ImporterAutomatizaciones'));
const UpdatesGestor = lazy(() => import('../automatizaciones/UpdatesGestor'));
const Trasbordos = lazy(() => import('../automatizaciones/Trasbordos'));
const Gestor315 = lazy(() => import('../315/gestor_315'));
const MasivoUpdate = lazy(() => import('../automatizaciones/updates_globales/macroUpdateGlobalExpo'));
const DataUpsert = lazy(() => import('../dataManagement/DataUpsert'));
const PrefolderConfig = lazy(() => import('../pages/app/PrefolderConfig/PrefolderConfig'));
const PrefolderAuditLog = lazy(() => import('../pages/app/PrefolderAuditLog/PrefolderAuditLog'));
const DowDashboard = lazy(() => import('../pages/app/DowDashboard/DowDashboard'));
const AlertasDashboard = lazy(() => import('../pages/app/AlertasDashboard/AlertasDashboard'));
const IsoTankDemurrage = lazy(() => import('../pages/app/IsoTankDemurrage/IsoTankDemurrage'));
const PermitsDashboard = lazy(() => import('../permitsDashboard/PermitsDashboard'));
const IssuesBoard = lazy(() => import('../issuesBoard/IssuesBoard'));
const Cargoes = lazy(() => import('../cargoes/Cargoes'));


//import Invest from "../pages/Invest";
const ExpoReportList = lazy(() =>
  import('../Exportation/Reports/custom-report/report-list')
);
const ReportsExpo = lazy(() =>
  import('../Exportation/Reports/custom-report/custom-report')
);
const Component = lazy(() => import('../pages/components/Index'));
const Accordian = lazy(() =>
  import('../pages/components/Accordions')
);
const Alerts = lazy(() => import('../pages/components/Alerts'));
const Badges = lazy(() => import('../pages/components/Badges'));
const Breadcrumbs = lazy(() =>
  import('../pages/components/Breadcrumbs')
);
const ButtonGroup = lazy(() =>
  import('../pages/components/ButtonGroup')
);
const Buttons = lazy(() => import('../pages/components/Buttons'));
const Cards = lazy(() => import('../pages/components/Cards'));
const Carousel = lazy(() => import('../pages/components/Carousel'));
const Dropdowns = lazy(() => import('../pages/components/Dropdowns'));
const FormElements = lazy(() =>
  import('../pages/components/forms/FormElements')
);
const FormLayouts = lazy(() =>
  import('../pages/components/forms/FormLayouts')
);
const FormValidation = lazy(() =>
  import('../pages/components/forms/FormValidation')
);
const Modals = lazy(() => import('../pages/components/Modals'));
const Pagination = lazy(() =>
  import('../pages/components/Pagination')
);
const Popovers = lazy(() => import('../pages/components/Popovers'));
const Progress = lazy(() => import('../pages/components/Progress'));
const Spinner = lazy(() => import('../pages/components/Spinner'));
const Tabs = lazy(() => import('../pages/components/Tabs'));
const Toast = lazy(() => import('../pages/components/Toast'));
const Tooltips = lazy(() => import('../pages/components/Tooltips'));
const UtilBorder = lazy(() =>
  import('../pages/components/UtilBorder')
);
const UtilColors = lazy(() =>
  import('../pages/components/UtilColors')
);
const UtilDisplay = lazy(() =>
  import('../pages/components/UtilDisplay')
);
const UtilEmbeded = lazy(() =>
  import('../pages/components/UtilEmbeded')
);
const UtilFlex = lazy(() => import('../pages/components/UtilFlex'));
const UtilOthers = lazy(() =>
  import('../pages/components/UtilOthers')
);
const UtilSizing = lazy(() =>
  import('../pages/components/UtilSizing')
);
const UtilSpacing = lazy(() =>
  import('../pages/components/UtilSpacing')
);
const UtilText = lazy(() => import('../pages/components/UtilText'));
const Blank = lazy(() => import('../pages/others/Blank'));
const Faq = lazy(() => import('../pages/others/Faq'));
const Regularv1 = lazy(() => import('../pages/others/Regular-1'));
const Regularv2 = lazy(() => import('../pages/others/Regular-2'));
const Terms = lazy(() => import('../pages/others/Terms'));
const BasicTable = lazy(() =>
  import('../pages/components/table/BasicTable')
);
const SpecialTablePage = lazy(() =>
  import('../pages/components/table/SpecialTable')
);
const ChartPage = lazy(() =>
  import('../pages/components/charts/Charts')
);
const EmailTemplate = lazy(() =>
  import('../pages/components/email-template/Email')
);
const NioIconPage = lazy(() =>
  import('../pages/components/crafted-icons/NioIcon')
);
const SVGIconPage = lazy(() =>
  import('../pages/components/crafted-icons/SvgIcons')
);
const ProjectCardPage = lazy(() =>
  import('../pages/pre-built/projects/ProjectCard')
);
const ProjectListPage = lazy(() =>
  import('../pages/pre-built/projects/ProjectList')
);
const UserListRegularPage = lazy(() =>
  import('../pages/pre-built/user-manage/UserListRegular')
);
const UserContactCardPage = lazy(() =>
  import('../pages/pre-built/user-manage/UserContactCard')
);
const UserDetailsPage = lazy(() =>
  import('../pages/pre-built/user-manage/UserDetailsRegular')
);
const UserListCompact = lazy(() =>
  import('../pages/pre-built/user-manage/UserListCompact')
);
const UserProfileLayout = lazy(() =>
  import('../pages/pre-built/user-manage/UserProfileLayout')
);
const KycListRegular = lazy(() =>
  import('../pages/pre-built/kyc-list-regular/KycListRegular')
);
const KycDetailsRegular = lazy(() =>
  import('../pages/pre-built/kyc-list-regular/kycDetailsRegular')
);
const TransListBasic = lazy(() =>
  import('../pages/pre-built/trans-list/TransListBasic')
);
const TransListCrypto = lazy(() =>
  import('../pages/pre-built/trans-list/TransListCrypto')
);
const ProductCard = lazy(() =>
  import('../pages/pre-built/products/ProductCard')
);
const ProductList = lazy(() =>
  import('../pages/pre-built/products/ProductList')
);
const ProductDetails = lazy(() =>
  import('../pages/pre-built/products/ProductDetails')
);
const InvoiceList = lazy(() =>
  import('../pages/pre-built/invoice/InvoiceList')
);
const InvoiceDetails = lazy(() =>
  import('../pages/pre-built/invoice/InvoiceDetails')
);
const PricingTable = lazy(() =>
  import('../pages/pre-built/pricing-table/PricingTable')
);
const Gallery = lazy(() =>
  import('../pages/pre-built/gallery/GalleryCard')
);
const AppMessages = lazy(() =>
  import('../pages/app/messages/Messages')
);
const Chat = lazy(() => import('../pages/app/chat/ChatContainer'));
const Calender = lazy(() => import('../pages/app/calender/Calender'));
const DateTimePicker = lazy(() =>
  import('../pages/components/forms/DateTimePicker')
);

//Importacion de Lista de Seller
const ListGsa = lazy(() => import('../listgsa'));
const SellerDetailsPage = lazy(() =>
  import('../listgsa/components/SellerDetails')
);
const DetallesdelSeller = lazy(() =>
  import('../listgsa/components/detallesdelseller')
);
const ListPlasticos = lazy(() => import('../plasticos'));
const DetailOrder = lazy(() =>
  import('../plasticos/components/detailorder')
);
const Followup = lazy(() =>
  import('../plasticos/components/followupreport')
);
const ContainerReport = lazy(() =>
  import('../Exportation/followUp/Components/followupcontainerreport')
);
const Calculadora = lazy(() => import('../tarifas'));
const PowerBi = lazy(() => import('../powerbi'));
const Importaciones = lazy(() => import('../dashimpo'));
const ReportImpo = lazy(() =>
  import('../plasticos/components/Reports/reportImpo')
);
const Arrivals = lazy(() =>
  import('../dashimpo/components/arrivals')
);
const PlasticOrigin = lazy(() =>
  import('../dashimpo/components/plasticorigin')
);
const ReportsExportation = lazy(() =>
  import('../Exportation/expoReport/reportsExportation')
);
const ExpoDashboard = lazy(() =>
  import('../Exportation/expoDashboard/expodashboard')
);
const FollowUpExportacion = lazy(() =>
  import('../Exportation/followUp/followUpExportacion')
);
const Reports = lazy(() =>
  import(
    '../plasticos/components/Reports/custom-report/custom-report'
  )
);
const ReportList = lazy(() =>
  import('../plasticos/components/Reports/custom-report/report-list')
);
const ViewCustomReport = lazy(() =>
  import(
    '../plasticos/components/Reports/custom-report/view-custom-report'
  )
);
const ExpoDetailOrder = lazy(() =>
  import('../Exportation/followUp/followUpExpoDetail')
);
const FollowUpExpoDemo = lazy(() =>
  import('../Exportation/followUp/followUpExpoDemo')
);
const ExpoDetailOrderDemo = lazy(() =>
  import('../Exportation/followUp/followUpExpoDetailDemo')
);
const Arrivals2 = lazy(() =>
  import('../dashimpo/components/arrivals2')
);

const MasterExpoDB = lazy(() =>
  import('../Exportation/followUp/master-expo-db')
);

const SubirDocumentoExcel = lazy(() =>
  import('../Exportation/followUp/Components/subirDocumeto')
);

const DashboardExpoBenefits = lazy(() =>
  import('../Exportation/benefits/Dashboard')
);

const ExcelUploaer = lazy(() =>
  import('../Exportation/benefits/ExcelUploader')
);

const Reintegros = lazy(() =>
  import('../Exportation/benefits/Reintegros')
);

const GestorExpo = lazy(() =>
  import('../Importer/Gestion_Carpetas/Expo/gestor_expo')
);

const CrearNuevaCarpeta = lazy(() =>
  import('../Importer/Gestion_Carpetas/Expo/crear_nueva_carpeta')
);

const SerialesCilindrosPage = lazy(() =>
  import('../Importer/cilindros/pages/SerialesCilindrosPage')
);

const TemporalesPage = lazy(() =>
  import('../Importer/temporales/pages/TemporalesPage')
);

const TransitosPage = lazy(() =>
  import('../Importer/transitos/pages/TransitosPage')
);

const GestionPage = lazy(() =>
  import('../Importer/gestion/pages/GestionPage')
);

const ConsumosPage = lazy(() =>
  import('../Importer/consumo_transitos/pages/ConsumosPage')
);

const GestionRetPage = lazy(() =>
  import('../Importer/gestion_ret/pages/GestionRetPage')
);

const ReintegrosObservados = lazy(() =>
  import('../Exportation/benefits/ReintegrosObservados')
);

const InterlogApi = lazy(() =>
  import('../interlogApi/interlogApi')
);

const InterlogBulk = lazy(() =>
  import('../interlogApi/interlogBulk')
);

const CargoRoutes = lazy(() =>
  import('../gestionRutas/CargoRoutes')
);

const GestionMails = lazy(() =>
  import('../gestionMails/GestionMails')
);

const IsotankManagement = lazy(() =>
  import('../APPO/IsotankManagement/IsotankManagement')
);

const DashboardAppo = lazy(() =>
  import('../APPO/Gestion/Dashboard')
);

const IsotankShipperOwnGestion = lazy(() =>
  import('../APPO/IsokantShipperOwnGestion/IsotankShipperOwnGestion')
);

const CilinderTemporaryAdmission = lazy(() =>
  import('../APPO/Cilinders/CilinderTemporaryAdmission')
);

const MroSubidaPagos = lazy(() =>
  import('../MRO/pagos/mro_subidaPagos')
);

const SubidaDocsMro = lazy(() =>
  import('../MRO/docs/subida_docs_mro')
);

const ReportesAccionesMro = lazy(() =>
  import('../MRO/acciones/reportes_acciones_mro')
);

const RemitosAutomatizacionMRO = lazy(() =>
  import('../automatizaciones/remitos-mro/RemitosAutomatizacionMRO')
);

const RemitosSubida = lazy(() =>
  import('../MRO/remitos/RemitosSubida')
);

const UsersAdmin = lazy(() =>
  import('../users_adm/UsersPage')
);

const JsonLogsPage = lazy(() =>
  import('../Importer/ver_json/pages/JsonLogsPage')
);

const TransportationReviewPage = lazy(() =>
  import('../Importer/transportation_method/pages/TransportationReviewPage')
);

const BotsImportadoresPage = lazy(() =>
  import('../Importer/bots_importadores/pages/BotsImportadoresPage')
);



const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div />}>
      <Switch>
        {/*Dashboards*/}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/crypto`}
          component={Crypto}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/automatizations-gestor-import`}
          render={() => <RolMetricProtectedRoute section="imports"><AutomatizationsGestorImpo /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/importer-automatizaciones`}
          render={() => <RolMetricProtectedRoute section="tools"><ImporterAutomatizaciones /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/automatizations-gestor-expo`}
          render={() => <RolMetricProtectedRoute section="exports"><AutomatizationsGestorExpo /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/gestor-315`}
          render={() => <RolMetricProtectedRoute section="exports"><Gestor315 /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/updates-globales`}
          render={() => <RolMetricProtectedRoute section="exports"><MasivoUpdate /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/ssb-reports-dashboard`}
          render={() => <RolMetricProtectedRoute section="imports"><SSBReportsDashboard /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/automatic-updates`}
          render={() => <RolMetricProtectedRoute section="imports"><UpdatesGestor /></RolMetricProtectedRoute>}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/analytics`}
          component={Analytics}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/sales`}
          component={Sales}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/_blank`}
          component={Blank}
        ></Route>

        {/*Pre-built Pages*/}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/project-card`}
          component={ProjectCardPage}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/project-list`}
          component={ProjectListPage}
        ></Route>
        <Route //Context Api added
          exact
          path={`${process.env.PUBLIC_URL}/user-list-regular`}
          render={() => (
            <UserContextProvider>
              <UserListRegularPage />
            </UserContextProvider>
          )}
        ></Route>
        <Route //Context Api added
          exact
          path={`${process.env.PUBLIC_URL}/user-list-compact`}
          render={() => (
            <UserContextProvider>
              <UserListCompact />
            </UserContextProvider>
          )}
        ></Route>
        <Route //Context Api added
          exact
          path={`${process.env.PUBLIC_URL}/user-details-regular/:id`}
          render={(props) => (
            <UserContextProvider>
              <UserDetailsPage {...props} />
            </UserContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/user-profile-regular/`}
          component={UserProfileLayout}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/user-profile-notification/`}
          component={UserProfileLayout}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/user-profile-activity/`}
          component={UserProfileLayout}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/user-profile-setting/`}
          component={UserProfileLayout}
        ></Route>
        <Route //Context api added
          exact
          path={`${process.env.PUBLIC_URL}/user-contact-card`}
          render={() => (
            <UserContextProvider>
              <UserContactCardPage />
            </UserContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/kyc-list-regular`}
          component={KycListRegular}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/kyc-details-regular/:id`}
          component={KycDetailsRegular}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/transaction-basic`}
          component={TransListBasic}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/transaction-crypto`}
          component={TransListCrypto}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/product-list`}
          component={ProductList}
        ></Route>

        <Route // context api added
          exact
          path={`${process.env.PUBLIC_URL}/product-card`}
          render={(props) => (
            <ProductContextProvider>
              <ProductCard />
            </ProductContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/product-details/:id`}
          render={(props) => (
            <ProductContextProvider>
              <ProductDetails {...props} />
            </ProductContextProvider>
          )}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/invoice-list`}
          component={InvoiceList}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/invoice-details/:id`}
          component={InvoiceDetails}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/pricing-table`}
          component={PricingTable}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/image-gallery`}
          component={Gallery}
        ></Route>

        {/*Demo Pages*/}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/pages/terms-policy`}
          component={Terms}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/pages/faq`}
          component={Faq}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/pages/regular-v1`}
          component={Regularv1}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/pages/regular-v2`}
          component={Regularv2}
        ></Route>

        {/*Application*/}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-messages`}
          component={AppMessages}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-chat`}
          component={Chat}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/app-calender`}
          component={Calender}
        ></Route>

        {/*Components*/}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components`}
          component={Component}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/accordions`}
          component={Accordian}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/alerts`}
          component={Alerts}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/badges`}
          component={Badges}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/breadcrumbs`}
          component={Breadcrumbs}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/button-group`}
          component={ButtonGroup}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/buttons`}
          component={Buttons}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/cards`}
          component={Cards}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/carousel`}
          component={Carousel}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/dropdowns`}
          component={Dropdowns}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/form-elements`}
          component={FormElements}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/form-layouts`}
          component={FormLayouts}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/form-validation`}
          component={FormValidation}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/datetime-picker`}
          component={DateTimePicker}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/modals`}
          component={Modals}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/pagination`}
          component={Pagination}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/popovers`}
          component={Popovers}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/progress`}
          component={Progress}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/spinner`}
          component={Spinner}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/tabs`}
          component={Tabs}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/toast`}
          component={Toast}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/tooltips`}
          component={Tooltips}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-border`}
          component={UtilBorder}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-colors`}
          component={UtilColors}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-display`}
          component={UtilDisplay}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-embeded`}
          component={UtilEmbeded}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-flex`}
          component={UtilFlex}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-others`}
          component={UtilOthers}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-sizing`}
          component={UtilSizing}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-spacing`}
          component={UtilSpacing}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/components/util-text`}
          component={UtilText}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/table-basic`}
          component={BasicTable}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/table-special`}
          component={SpecialTablePage}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/charts/chartjs`}
          component={ChartPage}
        ></Route>
        <Route
          exactdetailOrderex
          path={`${process.env.PUBLIC_URL}/email-template`}
          component={EmailTemplate}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/nioicon`}
          component={NioIconPage}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/svg-icons`}
          component={SVGIconPage}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/`}
          component={MetricsHome}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/expo-detailOrder/:po`}
          render={(props) => <RolMetricProtectedRoute section="exports"><ExpoDetailOrder {...props} /></RolMetricProtectedRoute>}
        ></Route>
        {/*demo new order*/}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/newOrder`}
          component={NewOrder}
        ></Route>
        { }
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/expo-detailOrderDemo/:po`}
          component={ExpoDetailOrderDemo}
        ></Route>

        {
          //Lista de Seller
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/listgsa`}
            component={ListGsa}
          ></Route>
        }
        {
          //Lista de Seller
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/listplasticos`}
            render={() => <RolMetricProtectedRoute section="imports"><ListPlasticos /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          //Data Management - Upsert (Bostik only)
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/data-upsert`}
            component={DataUpsert}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/prefolder-config`}
            render={() => <RolMetricProtectedRoute section="tools"><PrefolderConfig /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/prefolder-audit`}
            render={() => <RolMetricProtectedRoute section="tools"><PrefolderAuditLog /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dow-dashboard`}
            render={() => <RolMetricProtectedRoute section="tools"><DowDashboard /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/isotank-demurrage`}
            render={() => <RolMetricProtectedRoute section="imports"><IsoTankDemurrage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/permits-dashboard`}
            render={() => <RolMetricProtectedRoute section="tools"><PermitsDashboard /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/ops-alertas`}
            render={() => <RolMetricProtectedRoute section="tools"><AlertasDashboard /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/project-tracker`}
            render={() => <RolMetricProtectedRoute section="tools"><IssuesBoard apiBaseUrl={`${process.env.REACT_APP_BACKEND_URL}/issues`} /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route //Context Api added
            exact
            path={`${process.env.PUBLIC_URL}/seller-details/:id`}
            render={(props) => (
              <UserContextProvider>
                <SellerDetailsPage {...props} />
              </UserContextProvider>
            )}
          ></Route>
        }
        {
          <Route //Context Api added
            exact
            path={`${process.env.PUBLIC_URL}/detalleseller/:id`}
            render={(props) => <DetallesdelSeller {...props} />}
          ></Route>
        }
        {
          <Route //Context Api added
            exact
            path={`${process.env.PUBLIC_URL}/detallesorders/:id`}
            render={(props) => <PlasticOrigin {...props} />}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/detailorder/:id`}
            render={(props) => <RolMetricProtectedRoute section="imports"><DetailOrder {...props} /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/followup`}
            render={() => <RolMetricProtectedRoute section="imports"><Followup /></RolMetricProtectedRoute>}
          ></Route>
        }
        {/* Test */}
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/containerExport`}
            component={ContainerReport}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/follow-up-report`}
            component={FollowupReport}
          ></Route>
        }
        {/* user management */}
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/user_management`}
            component={UserManagement}
          ></Route>
        }
        {/*  */}
        {/* macroEdit  */}
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/macroUpdate`}
            render={() => <RolMetricProtectedRoute section="exports"><MacroUpdate /></RolMetricProtectedRoute>}
          ></Route>
        }
        {/*  */}
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/calculator`}
            component={Calculadora}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/powerbi`}
            component={PowerBi}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dashimpo`}
            component={Importaciones}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/followUpExpo`}
            render={() => <RolMetricProtectedRoute section="exports"><FollowUpExportacion /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/followUpExpoDemo`}
            component={FollowUpExpoDemo}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/reportExpo`}
            component={ReportsExportation}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dashboardExpo`}
            component={ExpoDashboard}
          ></Route>
        }
        {
          <Route
            exact
            path={`/reportImpo`}
            component={ReportImpo}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dragreport`}
            component={Reports}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dragreport/:reportId`}
            component={Reports}
          ></Route>
        }
        {
          <Route
            exact
            path={`/reportList`}
            component={ReportList}
          ></Route>
        }
        {
          <Route
            exact
            path={`/exporeportlist`}
            component={ExpoReportList}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dragreportexport`}
            component={ReportsExpo}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dragreportexport/:reportId`}
            component={ReportsExpo}
          ></Route>
        }
        {
          <Route
            exact
            path={`/viewExpoCustomReport/:reportId`}
            component={ViewExpoCustomReport}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/arrivals`}
            component={Arrivals}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/arrivals2`}
            component={Arrivals2}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/muestras`}
            render={() => <RolMetricProtectedRoute section="imports"><Muestras /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/trasbordos`}
            render={() => <RolMetricProtectedRoute section="imports"><Trasbordos /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/cargoes-ordenes`}
            render={() => <RolMetricProtectedRoute section="imports"><Cargoes /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/viewCustomReport/:reportId`}
            component={ViewCustomReport}
          ></Route>
        }
        {
          <Route
            exact
            path={`/expo/master-db`}
            render={() => <RolMetricProtectedRoute section="exports"><MasterExpoDB /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/subir-excel`}
            render={() => <RolMetricProtectedRoute section="exports"><SubirDocumentoExcel /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/help-documents`}
            component={Helperdocuments}
          ></Route>
        }
        {
          <Route
            exact
            path={`/dashboardExpoBenefits`}
            render={() => <RolMetricProtectedRoute section="exports"><DashboardExpoBenefits /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/dashboardExpoGestor`}
            render={() => <RolMetricProtectedRoute section="exports"><GestorExpo orderType="E" /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/dashboardImpoGestor`}
            render={() => <RolMetricProtectedRoute section="imports"><GestorExpo orderType="I" /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/gestor/crear-nueva-carpeta`}
            render={() => <RolMetricProtectedRoute section="exports"><CrearNuevaCarpeta /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/temporalesMro`}
            render={() => <RolMetricProtectedRoute section="mro"><TemporalesMro /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/seriales-cilindros`}
            render={() => <RolMetricProtectedRoute section="tools"><SerialesCilindrosPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/temporales`}
            render={() => <RolMetricProtectedRoute section="tools"><TemporalesPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/transitos`}
            render={() => <RolMetricProtectedRoute section="tools"><TransitosPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/gestion`}
            render={() => <RolMetricProtectedRoute section="tools"><GestionPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/consumo-transitos`}
            render={() => <RolMetricProtectedRoute section="tools"><ConsumosPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/gestion-ret`}
            render={() => <RolMetricProtectedRoute section="tools"><GestionRetPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`/excel-uploader`}
            component={ExcelUploaer}
          ></Route>
        }
        {
          <Route
            exact
            path={`/reintegros`}
            component={Reintegros}
          ></Route>
        }
        {
          <Route
            exact
            path={`/reintegros-observados`}
            component={ReintegrosObservados}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/cargoRoutes`}
            render={() => <RolMetricProtectedRoute section="tools"><CargoRoutes /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/gestion-mails`}
            render={() => <RolMetricProtectedRoute section="imports"><GestionMails /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/isotank-management`}
            render={() => <RolMetricProtectedRoute section="appo"><IsotankManagement /></RolMetricProtectedRoute>}
          ></Route>
        }

        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/dashboardAppo`}
            render={() => <RolMetricProtectedRoute section="appo"><DashboardAppo /></RolMetricProtectedRoute>}
          ></Route>
        }

        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/isotank-shipper-own-gestion`}
            render={() => <RolMetricProtectedRoute section="appo"><IsotankShipperOwnGestion /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/cilinder-temporary-admission`}
            render={() => <RolMetricProtectedRoute section="appo"><CilinderTemporaryAdmission /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/mro-payments-upload`}
            render={() => <RolMetricProtectedRoute section="mro"><MroSubidaPagos /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/mro/subida-docs`}
            render={() => <RolMetricProtectedRoute section="mro"><SubidaDocsMro /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/remitos/altas`}
            render={() => <RolMetricProtectedRoute section="remitos"><RemitosAltas /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/remitos/listado`}
            render={() => <RolMetricProtectedRoute section="remitos"><RemitosListado /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/remitos/configuracion`}
            render={() => <RolMetricProtectedRoute section="remitos"><RemitosConfig /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/remitos/alertas`}
            render={() => {
              try {
                const email = JSON.parse(localStorage.getItem('user') || '{}').email || '';
                if (!email.includes('@ssbint')) return <Redirect to="/" />;
              } catch { return <Redirect to="/" />; }
              return <RolMetricProtectedRoute section="remitos"><RemitosAlertas /></RolMetricProtectedRoute>;
            }}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/mro/acciones`}
            render={() => <RolMetricProtectedRoute section="mro"><ReportesAccionesMro /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/mro/automatizaciones/remitos`}
            render={() => <RolMetricProtectedRoute section="mro"><RemitosAutomatizacionMRO /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/mro/remitos/subida`}
            render={() => <RolMetricProtectedRoute section="mro"><RemitosSubida /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/users-admin`}
            render={() => <RolMetricProtectedRoute section="tools"><UsersAdmin /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/json-304`}
            render={() => <RolMetricProtectedRoute section="tools"><JsonLogsPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/bots`}
            render={() => <RolMetricProtectedRoute section="tools"><BotsImportadoresPage /></RolMetricProtectedRoute>}
          ></Route>
        }
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/transportation-method`}
            render={() => <RolMetricProtectedRoute section="tools"><TransportationReviewPage /></RolMetricProtectedRoute>}
          ></Route>
        }

        {/*404 Page*/}
        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/interlogApi`}
            render={() => <RolMetricProtectedRoute section="dispatches"><InterlogApi /></RolMetricProtectedRoute>}
          ></Route>
        }

        {
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/interlogBulk`}
            render={() => <RolMetricProtectedRoute section="tools"><InterlogBulk /></RolMetricProtectedRoute>}
          ></Route>
        }
        <Route component={RedirectAs404}></Route>
      </Switch>
    </Suspense>
  );
};
export default Pages;
